import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../GlobalServices/Destinations/Destinations.css";

const CustomerService = () => {
  return (
    <>
      <div className="Destination  pt-md-3">
        <div className="container ServiceOffering mb-0">
          <div className="row">
            <div className="col-md-12 ">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <h1 className="headings text-center">
                  <span>Unmatched </span>Customer Support
                </h1>
                {/* <p className="heading-para grotesk-headings text-center">
                            Blueberry Travel has made its way towards more than 30 strategic locations globally, offering top-tier travel services wherever your business journey takes you. From crowded cities to growing business hubs, we guarantee a smooth and flawless experience tailored to each unique market’s needs. Join us as we redefine business travel around the world!
                        </p> */}
              </div>
            </div>
          </div>
          <div className="row px-lg-5 px-md-0 px-4 mlTab">
            <div className="col-lg-4 col-md-4 col-12 mt-md-5 mt-3 d-flex justify-content-center">
              <div className="DT-box1 ">
                <div className="row">
                  <div className="col-md-12">
                    <div className="Destinations-img d-flex justify-content-center">
                      <LazyLoadImage
                        src="https://blueberrywebsites.azureedge.net/bbt/images/university1.svg"
                        alt=""
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings text-center desti-head-university">
                      IN-PERSON ASSISTANCE
                    </h5>
                    <p className="mt-3 text-center desti-para grotesk-headings">
                      We are specialized in crafting personalized itineraries
                      that match your unique interests and travel style.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12 mt-md-5 mt-3  d-flex justify-content-center">
              <div className="DT-box1 DT-boxx2">
                <div className="row">
                  <div className="col-md-12">
                    <div className="Destinations-img d-flex justify-content-center">
                      <LazyLoadImage
                        src="https://blueberrywebsites.azureedge.net/bbt/images/university2.svg"
                        alt=""
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings text-center desti-head-university">
                      24/7 AVAILABILITY
                    </h5>
                    <p className="mt-3 text-center desti-para grotesk-headings">
                      University travel is challenging but not impossible.
                      Whether it’s a last-minute question or emergency, our team
                      is available around the clock to help.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12 mt-md-5 mt-3  d-flex justify-content-center">
              <div className="DT-box1 DT-box3 ">
                <div className="row">
                  <div className="col-md-12">
                    <div className="Destinations-img d-flex justify-content-center">
                      <LazyLoadImage
                        src="https://blueberrywebsites.azureedge.net/bbt/images/university3.svg"
                        alt=""
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings text-center desti-head-university">
                      YOUR FEEDBACK MATTERS
                    </h5>
                    <p className="mt-3 text-center desti-para grotesk-headings">
                      We value your thoughts! Share your experience to help us
                      continuously improve and exceed your expectations.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerService;
